import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Arrowleft } from "../../images/arrow-left.svg";
import { ReactComponent as X } from "../../images/x.svg";
import { Table, TableBody, TableContainer, TableCell } from "@mui/material";
import { TableHead, TableRow, IconButton, FormHelperText } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Dialog,
  Checkbox,
} from "@mui/material/";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CheckIcon from "@mui/icons-material/Check";
import Loader from "../common/Loader";
import ProjectContext from "../../context/project/ProjectContext";
import AlertContext from "../../context/alert/AlertContext";
import AuthContext from "../../context/auth/AuthContext";
import projectTypeList from "../../data/projecttype.json";
import _ from "lodash";
import Construction from "./Construction";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

const NewDetailsPage = () => {
  const [active, setActive] = useState(true);
  const [detailOpen, setDetailOpen] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [errorObj, setErrorObj] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [monthDetailopen, setMonthDetailOpen] = useState(false);
  const [monthStatusForm, setMonthStatusForm] = useState({});
  const [riskList, setRiskList] = useState([]);
  const [scopeChangeopen, setScopeChangeOpen] = useState(false);
  const [projectScope, setProjectScope] = useState([]);
  const [initProjectScope, setInitProjectScope] = useState([]);
  const [projectScopeHistory, setProjectScopeHistory] = useState([]);
  const [scopeChangeData, setScopeChangeData] = useState({
    date: null,
    description: "",
  });
  const [submitScopeDisabled, setSubmitScopeDisabled] = useState(true);
  const [monthlyStatus, setMonthlyStatus] = useState([]);
  const [currentMonthlyStatus, setCurrentMonthlyStatus] = useState([]);
  const [constructionList, setConstructionList] = useState([]);
  const [selectedMonthlyStatus, setSelectedMonthlyStatus] = React.useState({});
  const [disableUpdate, setDisableUpdate] = React.useState(true);
  const [deleteDialog, setDeleteDialog] = React.useState(false);
  const [yearOption, setYearOption] = React.useState([]);
  const [ConstDashboardID, setConstDashboardID] = React.useState(null);
  const [portalItems, setPortalItems] = React.useState([]);
  const navigate = useNavigate();

  const projectContext = useContext(ProjectContext);
  const {
    selectedProject,
    updateProjectDetails,
    getProjectbyObjectId,
    getProjectsV2,
    getProjectScopeView,
    getProjectHistoryByObjectId,
    phases,
    getProjectScopeHistoryView,
    updateProjectScope,
    updateProjectScopeHistory,
    updatePhaseScopeHistory,
    getConstructionDashboardLink,
    getRisks,
    addMonthlyStatusRisk,
    deleteMonthlyStatusRisk,
    getMonthlyStatusByObjectId,
    getProjectMonthlyStatusView,
    addProjectMonthlyStatus,
    deleteProjectMonthlyStatus,
    getServiceAreasV2,
    updateServiceAreaStatusV2,
    intelliFiberUserRoles,
  } = projectContext;

  const alertContext = useContext(AlertContext);
  const { showSnackbar, showConfirmation, clearAlert } = alertContext;
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const current = () => {
    setActive(true);
  };

  const previous = () => {
    setActive(false);
  };

  const requiredFields = [
    "Name",
    "ProjectManager",
    "LeadOffice",
    "ProjectType",
    "EstimatedNoOfMiles",
    "ClientName",
    "Scope",
  ];

  const checkValidation = () => {
    let hasErrors = false;
    const errorObjCopy = { ...errorObj };

    for (const key in editForm) {
      if (editForm[key] === "") {
        hasErrors = true;
        errorObjCopy[key] = true;
      } else {
        errorObjCopy[key] = false;
      }
    }

    setErrorObj(errorObjCopy);

    console.log("Erorr Obj", errorObj);
    const isValid = requiredFields.every((key) => !errorObjCopy[key]);
    return isValid;
  };

  const getUserRoleType = () => {
    //check User's Role
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log("$$$USER :", user);
      const role = intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log("$$$USER Role:", role);
      if (role) {
        return role.RoleName ? role.RoleName : "";
      }
    }
    return "";
  };

  const handleDetailsSubmit = async () => {
    console.log("handleDetailsSubmit: props", editForm);

    const isValid = checkValidation();
    console.log("handleDetailsSubmit: isValid", isValid);

    if (isValid) {
      setLoading(true);
      delete editForm.ServiceAreas;
      const res = await updateProjectDetails(editForm);
      console.log("handleDetailsSubmit: res", res);

      if (res && res.length > 0) {
        try {
          let project = await getProjectbyObjectId(res[0].objectId);
          console.log(`handleDetailsSubmit: project"`, project);
          if (project[0]) {
            handleOnDetailClose();
            showSnackbar(
              `Project ${project[0].Name} has been updated Successfully`,
              "success"
            );
          }
        } catch (error) {
          console.log("handleDetailsSubmit: error", error);
          setLoading(false);
        }
        await getProjectsV2();
        setLoading(false);
      }
    }
  };

  const handleDetailsChange = (e) => {
    console.log("handleScopeChange: props", e.target.value);
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleProjectStatusChange = (e) => {
    console.log(
      "handleProjectStatusChange: props",
      e.target.value,
      e.target.checked,
      editForm.Status
    );
    setEditForm({
      ...editForm,
      ["Status"]: e.target.checked
        ? selectedProject.Status === "Inactive"
          ? "In Progress"
          : selectedProject.Status
        : "Inactive",
    });
  };

  const handleOnDetailOpen = () => {
    setEditForm(selectedProject);
    setDetailOpen(true);
  };

  const handleOnDetailClose = () => {
    // setEditForm({});
    setDetailOpen(false);
  };

  const deleteRiskStatus = async (StatusRisksObjectID) => {
    console.log("deleteRiskStatus: props", StatusRisksObjectID);
    if (deleteRiskStatus) {
      const res = await deleteMonthlyStatusRisk(StatusRisksObjectID);
      console.log("deleteRiskStatus: res", res);
      if (res) {
        return res;
      }
    }
  };

  const deleteMonthlyStatus = async () => {
    console.log("deleteMonthlyStatus: props", selectedMonthlyStatus);
    setLoading(true);
    if (deleteProjectMonthlyStatus) {
      const resRiskStatus = await deleteRiskStatus(
        selectedMonthlyStatus.StatusRisksObjectID
      );
      console.log("deleteMonthlyStatus: resRiskStatus", resRiskStatus);
      if (resRiskStatus) {
        const res = await deleteProjectMonthlyStatus(
          selectedMonthlyStatus.OBJECTID
        );
        console.log("deleteMonthlyStatus: res", res);
        if (res) {
          await fetchProjectMonthlyStatusView();
          setDeleteDialog(false);
          setLoading(false);
          showSnackbar(`Succesfully deleted monthly status `, "success");
        }
      }
    }
  };

  const handleMonthlyStatusDelete = (rowData) => {
    console.log("handleMonthlyStatusDelete: props", rowData);
    setSelectedMonthlyStatus(rowData);
    setDeleteDialog(true);
  };

  const closeDelete = () => {
    console.log("closeDelete");
    setSelectedMonthlyStatus({});
    setDeleteDialog(false);
  };

  const updateRiskStatus = async (monthyRisk) => {
    console.log("updateRiskStatus: props", monthyRisk);
    if (addMonthlyStatusRisk) {
      try {
        let payload = {
          RiskId: parseInt(monthyRisk.riskStatus),
          ProjectStatusId: monthyRisk.ProjectStatusId,
          GlobalID: monthyRisk.StatusRisksGlobalID,
          OBJECTID: monthyRisk.StatusRisksObjectID,
        };
        console.log("updateRiskStatus: payload", payload);
        const resp = await addMonthlyStatusRisk(payload, "UPDATE");
        console.log("updateRiskStatus: resp", resp);
        if (resp) {
          handleOnMonthDetailClose();
          await fetchProjectMonthlyStatusView();
          showSnackbar(`Succesfully updated monthly status `, "success");
          setLoading(false);
        }
      } catch (err) {
        console.log("updateRiskStatus: err", err);
        showSnackbar(`Unexpected Error`, "error");
      }
    }
  };

  const handleMonthlyStatusUpdate = async () => {
    console.log(
      "handleMonthlyStatusUpdate: props",
      selectedMonthlyStatus,
      monthStatusForm
    );
    if (addProjectMonthlyStatus) {
      setLoading(true);
      let formdata = {
        ...monthStatusForm,
        PMInsights: monthStatusForm.PMInsights,
        IsOnSchedule: monthStatusForm.IsOnSchedule,
        HasEnoughResources: monthStatusForm.HasEnoughResources,
        FullYearBillingEst: parseInt(monthStatusForm.FullYearBillingEst),
      };
      console.log("handleMonthlyStatusUpdate: formdata", formdata);
      const res = await addProjectMonthlyStatus(formdata, "UPDATE");
      console.log("handleMonthlyStatusUpdate: res", res);
      console.log(
        "handleMonthlyStatusUpdate: riskStatus",
        selectedMonthlyStatus.riskStatus,
        monthStatusForm.riskStatus
      );
      if (selectedMonthlyStatus.riskStatus !== monthStatusForm.riskStatus) {
        updateRiskStatus(monthStatusForm);
      } else {
        handleOnMonthDetailClose();
        await fetchProjectMonthlyStatusView();
        showSnackbar(`Succesfully updated monthly status `, "success");
        setLoading(false);
      }
    }
  };

  const monthStatusChanged = (obj1, obj2) => {
    console.log("monthStatusChanged: props", obj1, obj2);
    let statusSame = _.isEqual(obj1, obj2);
    console.log("monthStatusChanged: statusSame", statusSame);
    setDisableUpdate(statusSame);
  };

  const handleMonthlyStatusEdit = (rowData) => {
    console.log("handleMonthlyStatusEdit: props", rowData);
    let monthlyUpdate = rowData;
    let date = formatDate(rowData.StatusDate);
    monthlyUpdate.year = date.length
      ? date.slice(date.length - 4, date.length)
      : "";
    monthlyUpdate.month = date.length
      ? date.slice(date.length - 7, date.length - 5)
      : "";
    monthlyUpdate.riskStatus = rowData.RiskId;
    console.log("handleMonthlyStatusEdit: monthlyUpdate", monthlyUpdate);
    setSelectedMonthlyStatus(monthlyUpdate);
    setMonthStatusForm(monthlyUpdate);
    setMonthDetailOpen(true);
    monthStatusChanged(monthlyUpdate, monthlyUpdate);
  };

  const addRiskStatus = async (objectId) => {
    console.log("addRiskStatus: props", objectId);
    if (getMonthlyStatusByObjectId && addMonthlyStatusRisk) {
      try {
        const res = await getMonthlyStatusByObjectId(objectId);
        console.log("addRiskStatus res", res);
        if (res) {
          try {
            let payload = {
              RiskId: parseInt(monthStatusForm.riskStatus),
              ProjectStatusId: res[0].ProjectStatusId,
            };
            console.log("addRiskStatus: payload", payload);
            const resp = await addMonthlyStatusRisk(payload, "ADD");
            console.log("addRiskStatus: resp", resp);
            if (resp) {
              handleOnMonthDetailClose();
              await fetchProjectMonthlyStatusView();
              showSnackbar(`Succesfully added monthly status `, "success");
              setLoading(false);
            }
          } catch (err) {
            console.log("addRiskStatus: err", err);
            showSnackbar(`Unexpected Error`, "error");
          }
        }
      } catch (err) {
        console.log("addRiskStatus: err", err);
        showSnackbar(`Unexpected Error`, "error");
      }
    }
  };

  const handleMonthlyStatusSubmit = async () => {
    console.log("handleMonthlyStatusSubmit: props", monthStatusForm);
    setLoading(true);

    let millisecondDate = new Date(
      monthStatusForm.year,
      monthStatusForm.month - 1,
      1
    ).getTime();
    console.log(
      "handleMonthlyStatusSubmit: millisecondDate",
      millisecondDate,
      monthlyStatus,
      currentMonthlyStatus
    );

    let isMonthExist = monthlyStatus.filter(
      (ele) =>
        formatDate(ele.StatusDate, true) === formatDate(millisecondDate, true)
    );
    console.log("handleMonthlyStatusSubmit: isMonthExist", isMonthExist);

    let currentMonthExist = currentMonthlyStatus.filter(
      (ele) =>
        formatDate(ele.StatusDate, true) === formatDate(millisecondDate, true)
    );
    console.log(
      "handleMonthlyStatusSubmit: currentMonthExist",
      currentMonthExist
    );

    if (isMonthExist.length > 0 || currentMonthExist.length > 0) {
      setLoading(false);
      showSnackbar(`Monthly Status already exists `, "warning");
      return;
    }

    if (addProjectMonthlyStatus) {
      let formdata = {
        PMInsights: monthStatusForm.PMInsights,
        IsOnSchedule: monthStatusForm.IsOnSchedule,
        HasEnoughResources: monthStatusForm.HasEnoughResources,
        StatusDate: millisecondDate,
        ProjectID: selectedProject?.ID,
        FullYearBillingEst: parseInt(monthStatusForm.FullYearBillingEst),
      };
      console.log("handleMonthlyStatusSubmit: formdata", formdata);
      const res = await addProjectMonthlyStatus(formdata, "ADD");
      console.log("handleMonthlyStatusSubmit: res", res);
      if (res) {
        addRiskStatus(res[0].objectId);
      }
    }
  };

  const handleStatusChange = (e) => {
    console.log("handleScopeChange: props", e.target.value);
    let changedStatus = { ...monthStatusForm, [e.target.name]: e.target.value };
    console.log("handleScopeChange: changedStatus", changedStatus);
    setMonthStatusForm(changedStatus);
    if (selectedMonthlyStatus.month) {
      monthStatusChanged(selectedMonthlyStatus, changedStatus);
    }
  };

  const clearMonthStatusForm = () => {
    setMonthStatusForm({
      PMInsights: "",
      IsOnSchedule: "",
      HasEnoughResources: "",
      month: "",
      year: "",
      FullYearBillingEst: "",
    });
  };

  const handleOnMonthDetailOpen = () => {
    setMonthDetailOpen(true);
  };

  const handleOnMonthDetailClose = () => {
    setSelectedMonthlyStatus({});
    clearMonthStatusForm();
    setMonthDetailOpen(false);
  };

  const formatDate = (ScopeChangeDate, monthYear) => {
    console.log("formatDate: props", ScopeChangeDate);
    let format;
    if (monthYear) {
      format = new Date(ScopeChangeDate).toLocaleString("default", {
        month: "short",
        year: "numeric",
      });
    } else {
      format = new Date(ScopeChangeDate)
        .toLocaleString("default", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replaceAll("/", "-");
      // format = new Date(parseInt(ScopeChangeDate)).toISOString().split('T')[0];
    }
    console.log("formatDate: format", format);
    return format !== "Invalid Date" ? format : "";
  };

  const fetchProjectScopeHistoryView = async () => {
    console.log("fetchProjectScopeHistoryView: props", selectedProject?.ID);
    if (getProjectScopeView && selectedProject) {
      try {
        const res = await getProjectScopeHistoryView(selectedProject.ID);
        console.log("fetchProjectScopeHistoryView res", res);

        const mergeScopeList = res.reduce((obj, item) => {
          obj[item.ProjectScopeHistoryId]
            ? obj[item.ProjectScopeHistoryId].Changes.push({
                Action: item.Action,
                PhaseName: item.PhaseName,
              })
            : (obj[item.ProjectScopeHistoryId] = {
                ...item,
                Changes: [{ Action: item.Action, PhaseName: item.PhaseName }],
              });
          return obj;
        }, []);
        console.log(
          "fetchProjectScopeHistoryView mergeScopeList",
          mergeScopeList
        );

        let sortScopeList = mergeScopeList.sort(
          (a, b) => new Date(b.ScopeChangeDate) - new Date(a.ScopeChangeDate)
        );
        console.log(
          "fetchProjectScopeHistoryView sortScopeList",
          sortScopeList
        );

        setProjectScopeHistory(sortScopeList);
      } catch (error) {
        console.log("fetchProjectScopeHistoryView: Error:", error);
      }
    }
  };

  const handleOnScopeChangeOpen = async () => {
    await fetchProjectScopeHistoryView();
    setScopeChangeOpen(true);
  };

  const handleOnScopeChangeClose = () => {
    setProjectScopeHistory([]);
    setScopeChangeOpen(false);
  };

  const updateScopeStatus = async () => {
    console.log("updateScopeStatus: props", projectScope, initProjectScope);
    const res = await updateScope();
    console.log("updateScopeStatus res", res);
    if (res) {
      showSnackbar(`Succesfully updated scope status `, "success");
    }
  };

  const isInScopeChanged = () => {
    console.log("isInScopeChanged:", projectScope, initProjectScope);
    return projectScope.filter(
      (ele, i) => ele.IsInScope !== initProjectScope[i].IsInScope
    );
  };

  const updatePhaseHistory = async (objectId) => {
    console.log("updatePhaseHistory: props", objectId);
    if (getProjectHistoryByObjectId && updatePhaseScopeHistory) {
      const res = await getProjectHistoryByObjectId(objectId);
      console.log("updatePhaseHistory res", res);
      if (res) {
        let scopeChange = isInScopeChanged();
        console.log("updatePhaseHistory: scopeChange", scopeChange);
        let payload = scopeChange.map((ele) => {
          return {
            ProjectScopeHistoryId: res[0].ProjectScopeHistoryId,
            PhaseId: ele.PhaseId,
            Action: ele.IsInScope === "Yes" ? "Added" : "Removed",
          };
        });
        console.log("updatePhaseHistory payload", payload);
        let resp = await updatePhaseScopeHistory(payload);
        console.log("updatePhaseHistory resp", resp);
        if (resp) {
          let initScope = _.cloneDeep(projectScope);
          setInitProjectScope(initScope);
          showSnackbar(`Succesfully submited scope`, "success");
          setScopeChangeData({ date: null, description: "" });
          setLoading(false);
        }
      }
    }
  };

  const updateScopeHistory = async () => {
    console.log("updateScopeHistory: props", scopeChangeData);
    if (updateProjectScopeHistory) {
      try {
        let millisecondDate = new Date(scopeChangeData.date).getTime();
        console.log("updateScopeHistory: millisecondDate", millisecondDate);
        let formData = {
          ProjectID: selectedProject?.ID,
          ScopeChangeDate: millisecondDate,
          ScopeChangeComment: scopeChangeData.description,
        };
        console.log("updateScopeHistory formData", formData);

        const res = await updateProjectScopeHistory(formData);
        console.log("updateScopeHistory res", res);
        if (res) {
          updatePhaseHistory(res[0].objectId);
        }
      } catch (error) {
        console.log("updateScopeHistory: Error:", error);
      }
    }
  };

  const updateScope = async () => {
    console.log("updateScope: props", projectScope);
    if (updateProjectScope) {
      try {
        let res;
        if (projectScope[0].ProjectID) {
          res = await updateProjectScope(projectScope, "UPDATE");
        } else {
          let scope = projectScope.map((ele) => ({
            ...ele,
            ProjectID: selectedProject?.ID,
          }));
          res = await updateProjectScope(scope, "ADD");
        }
        console.log("updateScope res", res);
        return res;
      } catch (error) {
        console.log("updateScope: Error:", error);
      }
    }
  };

  const handleScopeSubmit = async () => {
    console.log("handleScopeSubmit: props", projectScope, initProjectScope);
    setLoading(true);
    setSubmitScopeDisabled(true);
    const res = await updateScope();
    console.log("handleScopeSubmit res", res);
    if (res) {
      const resp = await updateScopeHistory();
      console.log("handleScopeSubmit resp", resp);
    }
  };

  const handleScopeChange = (e, PhaseId, property) => {
    console.log("handleScopeChange: props", e.target.value, PhaseId, property);
    let scope = projectScope.map((ele) => {
      if (ele.PhaseId === PhaseId) {
        ele[property] = e.target.value;
      }
      return ele;
    });
    console.log("handleScopeChange: scope", scope);
    setProjectScope(scope);
    if (property === "IsInScope") {
      isScopeChanged();
    }
  };

  let isScopeChanged = () => {
    console.log("isScopeChanged: props", scopeChangeData);
    let scopeChange = isInScopeChanged();
    console.log("isScopeChanged: scopeChange", scopeChange);
    if (
      scopeChangeData.date !== null &&
      scopeChangeData.description !== "" &&
      scopeChange.length > 0
    ) {
      setSubmitScopeDisabled(false);
    } else {
      setSubmitScopeDisabled(true);
    }
  };

  useEffect(() => {
    console.log("submitScopeDisabled: props", submitScopeDisabled);
    isScopeChanged();
    //eslint-disable-next-line
  }, [scopeChangeData.date, scopeChangeData.description]);

  const updateSAStatus = async () => {
    setLoading(true);
    console.log("updateSAStatus props", constructionList);
    if (updateServiceAreaStatusV2) {
      try {
        let updateList = constructionList
          .filter((ele) => ele.isSelected === true && ele.isDisabled === false)
          .map((ele) => {
            ele.Status = "Approved for Construction";
            ele.AR_Trigger = "FILTER,JSI8675309";
            return ele;
          });
        console.log("updateSAStatus updateList", updateList);
        let updateCall = updateList.map((ele, i) => {
          return new Promise(async (resolve, reject) => {
            let updateRes = await updateServiceAreaStatusV2(ele);
            console.log("updateSAStatus updateRes", updateRes, ele);

            if (updateRes) {
              resolve(updateRes);
            } else {
              reject(updateRes);
            }
          });
        });

        let res = await Promise.all(updateCall);
        console.log("updateSAStatus res", res);
        if (res) {
          await fetchProjectServiceAreas();
          showSnackbar(`Succesfully updated service area status `, "success");
          setLoading(false);
        }
      } catch (error) {
        console.log("updateSAStatus error", error);
        await fetchProjectServiceAreas();
        setLoading(false);
        showSnackbar(`Unexpected error while updating`, "error");
      }
    }
  };

  const approveConstruction = () => {
    showConfirmation &&
      showConfirmation(
        "Once Approved for Consruction, Design can not be changed for these Service Area(s). Please confirm ",
        "confirm",
        updateSAStatus
      );
  };

  // const isAllSelected = () => {
  //   console.log('isAllSelected props', constructionList);
  //   let findUnselected = constructionList.find(
  //     (ele) => ele.isSelected !== false
  //   );
  //   console.log('isAllSelected findUnselected', findUnselected);
  //   return findUnselected ? true : false;
  // };

  const selectAllConstruction = (e) => {
    console.log(
      "selectAllConstruction props",
      e.target.checked,
      constructionList
    );
    let newSelected = constructionList.map((ele) => {
      if (ele.isDisabled !== true) {
        ele.isSelected = e.target.checked;
      }
      return ele;
    });

    console.log("selectAllConstruction newSelected", newSelected);
    setConstructionList(newSelected);
  };

  const selectConstruction = (event, id) => {
    console.log("selectConstruction props", event, id);

    let newSelected = constructionList.map((ele) => {
      if (ele.OBJECTID === id) {
        ele.isSelected = !ele.isSelected;
      }
      return ele;
    });

    console.log("selectConstruction newSelected", newSelected);
    setConstructionList(newSelected);
  };

  const fetchProjectRisks = async () => {
    console.log("fetchProjectRisks: props", selectedProject?.ID);
    if (getProjectScopeView && selectedProject) {
      try {
        const res = await getRisks();
        console.log("fetchProjectRisks res", res);
        setRiskList(res);
      } catch (error) {
        console.log("fetchProjectRisks: Error:", error);
      }
    }
  };

  const fetchProjectMonthlyStatusView = async () => {
    console.log("fetchProjectMonthlyStatusView: props", selectedProject?.ID);
    if (getProjectScopeView && selectedProject) {
      try {
        const res = await getProjectMonthlyStatusView(selectedProject.ID);
        console.log("fetchProjectMonthlyStatusView res", res);
        if (res) {
          let currentMonth = new Date().toLocaleString("default", {
            month: "short",
            year: "numeric",
          });
          console.log(
            "fetchProjectMonthlyStatusView currentMonth",
            currentMonth
          );

          let currentStatus = [];
          let prevStatus = [];
          res.forEach((ele) => {
            if (formatDate(ele.StatusDate, true) === currentMonth) {
              currentStatus.push(ele);
            } else {
              prevStatus.push(ele);
            }
          });

          console.log(
            "fetchProjectMonthlyStatusView status",
            currentStatus,
            prevStatus
          );
          setCurrentMonthlyStatus(currentStatus);
          let sortPrevStatus = prevStatus.sort(
            (a, b) => new Date(b.StatusDate) - new Date(a.StatusDate)
          );
          console.log("fetchProjectMonthlyStatusView status sort", prevStatus);
          setMonthlyStatus(sortPrevStatus);
        }
      } catch (error) {
        console.log("fetchProjectMonthlyStatusView: Error:", error);
      }
    }
  };

  const fetchProjectScopeView = async () => {
    console.log("fetchProjectScopeView: props", selectedProject?.ID);
    if (getProjectScopeView && selectedProject) {
      try {
        const res = await getProjectScopeView(selectedProject.ID);
        console.log("fetchProjectScopeView res", res, phases);
        let scope = phases.map((phase) => {
          let phaseExists = res.find((ele) => ele.PhaseId === phase.PhaseId);
          //console.log("fetchProjectScopeView phaseExists", phaseExists);
          if (phaseExists) {
            return phaseExists;
          } else {
            return {
              PhaseId: phase.PhaseId,
              PhaseName: phase.PhaseName,
              IsInScope: null,
              PhasePercentComplete: null,
            };
          }
        });
        console.log("fetchProjectScopeView scope", scope);
        setProjectScope(scope);
        let initScope = _.cloneDeep(scope);
        setInitProjectScope(initScope);
      } catch (error) {
        console.log("fetchProjectScopeView: Error:", error);
      }
    }
  };

  const fetchProjectServiceAreas = async () => {
    console.log("fetchProjectServiceAreas: props", selectedProject?.ID);
    if (getServiceAreasV2 && selectedProject) {
      try {
        const res = await getServiceAreasV2(selectedProject.ID);
        console.log("fetchProjectServiceAreas: res", res);
        let mapConstructionList = res
          .map((ele) => {
            return {
              ...ele,
              isSelected: ele.Status === "Approved for Construction",
              isDisabled: ele.Status === "Approved for Construction",
            };
          })
          .sort((a, b) =>
            a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : -1
          );
        console.log(
          "fetchProjectServiceAreas: mapConstructionList",
          mapConstructionList
        );
        setConstructionList(mapConstructionList);
      } catch (error) {
        console.log("fetchProjectServiceAreas: error", error);
      }
    }
  };

  const getPortalItemID = (ItemType) => {
    let PortalItemID = null;
    console.log("Items to be checked:", portalItems);
    if (portalItems && portalItems.length > 0) {
      PortalItemID = portalItems.find(
        (ele) => ele.ItemType === ItemType
      )?.PortalItemID;
    }
    return PortalItemID;
  };

  const fetchProjectItems = async () => {
    if (getConstructionDashboardLink && selectedProject) {
      try {
        const res = await getConstructionDashboardLink(selectedProject?.ID);
        console.log("handleConstructionDashboardLink res", res);
        // let PortalItemID = res.find(
        //   (ele) => ele.ItemType === "Construction Dashboard"
        // ).PortalItemID;
        if (res) setPortalItems(res);
        console.log("Fetch all PortalItemID", res);
      } catch (error) {
        console.log("handleConstructionDashboardLink: Error:", error);
      }
    }
  };

  useEffect(() => {
    console.log("NewDetailsPage: selectedProject", selectedProject);
    if (selectedProject && initProjectScope.length <= 0) {
      fetchProjectScopeView();
      fetchProjectMonthlyStatusView();
      fetchProjectRisks();
      fetchProjectServiceAreas();
      fetchProjectItems();
      let currentYear = new Date().getFullYear();
      setYearOption([currentYear - 1, currentYear, currentYear + 1]);
    }
    //eslint-disable-next-line
  }, [selectedProject]);

  return (
    <div className='main-container'>
      {loading && <Loader />}
      <div className='project-name'>
        <Arrowleft
          onClick={() => navigate("/")}
          style={{ cursor: "pointer", color: "#00499b" }}
        />
        <h6
          onClick={() => navigate("/")}
          style={{ cursor: "pointer", color: "#00499b" }}
        >
          {` `}Back to Project Summary{" "}
        </h6>
      </div>
      <div className='project-details'>
        <div className='Details-1'>
          <div className='details_row'>
            <div className='details'>
              <h6>NetSuite ID :</h6>
              <p>{selectedProject?.NetSuiteID}</p>
            </div>
            <div className='details'>
              <h6>Intelli-Fiber Project ID :</h6>
              <p>{selectedProject?.ID}</p>
            </div>
          </div>
          {/* <div className='details'>
            <h6>Project ID</h6>
            <p>{selectedProject?.}</p>
          </div> */}
          <div className='details_row'>
            <div className='details'>
              <h6>Project Name :</h6>
              <p>{selectedProject?.Name}</p>
            </div>
            <div className='details'>
              <h6>Client Primary Contact :</h6>
              <p>{selectedProject?.ClientPrimaryContact}</p>
            </div>
          </div>
          <div className='details_row'>
            <div className='details'>
              <h6>Project Lead :</h6>
              <p>{selectedProject?.ProjectManager}</p>
            </div>
            <div className='details'>
              <h6>Client Contact Phone :</h6>
              <p>{selectedProject?.ClientContactPhone}</p>
            </div>
          </div>
          <div className='details_row'>
            <div className='details'>
              <h6>Lead Office :</h6>
              <p>{selectedProject?.LeadOffice}</p>
            </div>
            <div className='details'>
              <h6>Client Contact Email :</h6>
              <p>{selectedProject?.ClientContactEmail}</p>
            </div>
          </div>
          <div className='details_row'>
            <div className='details'>
              <h6>Project Type :</h6>
              <p>{selectedProject?.ProjectType}</p>
            </div>
            <div className='details'>
              <h6>Estimated Route Miles :</h6>
              <p>{selectedProject?.EstimatedNoOfMiles}</p>
            </div>
          </div>
          <div className='details_row'>
            <div className='details'>
              <h6>Client Name :</h6>
              <p>{selectedProject?.ClientName}</p>
            </div>
            <div className='details'>
              <h6>Est of Premises :</h6>
              <p>{selectedProject?.EstNoOfPremises}</p>
            </div>
          </div>
        </div>
        {/* 
        <div className='Details-1'>
          <div className='details'>
            <h6>Client Primary Contact :</h6>
            <p>{selectedProject?.ClientPrimaryContact}</p>
          </div>
          <div className='details'>
            <h6>Client Contact Phone :</h6>
            <p>{selectedProject?.ClientContactPhone}</p>
          </div>
          <div className='details'>
            <h6>Client Contact Email :</h6>
            <p>{selectedProject?.ClientContactEmail}</p>
          </div>
          <div className='details'>
            <h6>Estimated Route Miles :</h6>
            <p>{selectedProject?.EstimatedNoOfMiles}</p>
          </div>
          <div className='details'>
            <h6>Est of Premises :</h6>
            <p>{selectedProject?.EstNoOfPremises}</p>
          </div>
        </div> */}
      </div>
      <div className='description'>
        <h6>Project Description :</h6>
        <p>{selectedProject?.Description}</p>
      </div>
      <div className='edit'>
        <button
          disabled={getUserRoleType() !== "Central GIS Team"}
          onClick={handleOnDetailOpen}
        >
          Edit Details
        </button>
      </div>
      <Dialog open={detailOpen} onClose={handleOnDetailClose} maxWidth='lg'>
        <div className='detail-form'>
          <div className='form-header'>
            <h6>
              EDIT (Project Id:{selectedProject?.ID}, Project Name:
              {selectedProject?.Name})
            </h6>
            <button onClick={handleOnDetailClose}>
              <X />
            </button>
          </div>
          <div className='border' />
          <div className='detail-inputs'>
            <form>
              <div className='inputs'>
                <label for='netsuit ID'>NetSuite ID</label>
                <input
                  type='text'
                  placeholder=''
                  name='NetSuiteID'
                  value={editForm?.NetSuiteID}
                  onChange={handleDetailsChange}
                />
              </div>
              <div className='inputs'>
                <label for='project lead'>Project Lead</label>
                <input
                  type='text'
                  placeholder=''
                  name='ProjectManager'
                  value={editForm?.ProjectManager}
                  onChange={handleDetailsChange}
                />
              </div>
              <div className='inputs'>
                <label for='lead office'>Lead Office</label>
                <input
                  type='text'
                  placeholder=''
                  name='LeadOffice'
                  value={editForm?.LeadOffice}
                  onChange={handleDetailsChange}
                />
              </div>
              <div className='inputs'>
                <label for='client name'>Client Name</label>
                <input
                  type='text'
                  placeholder=''
                  name='ClientName'
                  value={editForm?.ClientName}
                  onChange={handleDetailsChange}
                />
                {errorObj.ClientName && (
                  <FormHelperText error={true}>
                    Please enter a Client Name{" "}
                  </FormHelperText>
                )}
              </div>
              <div className='inputs'>
                <label for='client primary contact'>
                  Client Primary Contact
                </label>
                <input
                  type='text'
                  placeholder=''
                  name='ClientPrimaryContact'
                  value={editForm?.ClientPrimaryContact}
                  onChange={handleDetailsChange}
                />
              </div>
              <div className='inputs'>
                <label for='client phone'>Client Contact Phone</label>
                <input
                  type='text='
                  placeholder=''
                  name='ClientContactPhone'
                  value={editForm?.ClientContactPhone}
                  onChange={handleDetailsChange}
                />
              </div>
              <div className='inputs'>
                <label for='project type'>Project Type</label>
                <select
                  name='ProjectType'
                  id='project type'
                  value={editForm?.ProjectType}
                  onChange={handleDetailsChange}
                >
                  <option selected>{}</option>
                  {projectTypeList &&
                    projectTypeList.map((type, index) => (
                      <option key={type.Name} value={type.Name}>
                        {type.Name}
                      </option>
                    ))}
                </select>
              </div>
              <div className='inputs'>
                <label for='est miles'>Estimated Route Miles</label>
                <input
                  type='text'
                  placeholder=''
                  name='EstimatedNoOfMiles'
                  value={editForm?.EstimatedNoOfMiles}
                  onChange={handleDetailsChange}
                />
                {errorObj.EstimatedNoOfMiles && (
                  <FormHelperText error={true}>
                    Please enter Estimated Route Miles{" "}
                  </FormHelperText>
                )}
              </div>
              <div className='inputs'>
                <label for='est premises'>EST of Premises</label>
                <input
                  type='text'
                  placeholder=''
                  name='EstNoOfPremises'
                  value={editForm?.EstNoOfPremises}
                  onChange={handleDetailsChange}
                />
              </div>
            </form>
            <div className='project-description'>
              <label for='description'>Project Description</label>
              <textarea
                rows='3'
                placeholder='Enter Details...'
                name='Description'
                value={editForm?.Description}
                onChange={handleDetailsChange}
              />
            </div>
          </div>
          <div className='action-block'>
            <div className='status-block'>
              <div>
                <b>Status:</b>
              </div>
              <div>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={editForm?.Status !== "Inactive"}
                        onChange={handleProjectStatusChange}
                      />
                    }
                    label={
                      editForm?.Status === "Inactive"
                        ? editForm?.Status
                        : "Active"
                    }
                  />
                </FormGroup>
              </div>
            </div>
            <div className='reset-submit'>
              <button onClick={handleOnDetailClose}>Reset</button>
              <button onClick={handleDetailsSubmit}>Submit</button>
            </div>
          </div>
        </div>
      </Dialog>
      <div className='border' />

      <div className='design-constraction'>
        <h6 style={{ marginBottom: "1rem" }}>Quick Links</h6>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>
                  <h6>Design</h6>
                </TableCell>
                <TableCell>
                  <h6>Construction</h6>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <h6>Maps</h6>
                </TableCell>
                <TableCell>
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_DESIGN}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Detailed Design Map
                    </a>
                  </p>
                </TableCell>
                <TableCell>
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_CONSTRUCTION_MAP}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Construction & Inspection Map
                    </a>
                  </p>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <h6>Reports</h6>
                </TableCell>
                <TableCell>
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_TABULATION_REPORT}&ProjectID=${selectedProject?.ID}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Tabulation Report
                    </a>
                  </p>
                </TableCell>
                <TableCell>
                  {
                   <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_CONSTRUCTION_TABULATION_REPORT}&ProjectID=${selectedProject?.ID}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Construction Tabulation Report
                    </a>
                  </p>
                  /* {getPortalItemID("Construction Tabulation Report") && (
                    <p>
                      {<a
                        href={`${
                          process.env.REACT_APP_PORTAL_URL
                        }/apps/experiencebuilder/experience/?id=/${getPortalItemID(
                          "Construction Tabulation Report"
                        )}`}
                        target='_blank'
                        rel='noreferrer'
                      > }
                        Construction Tabulation Report
                      </a>
                    </p>
                  )} */}
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_INSPECTION_REPORT}&projectId=${selectedProject?.ID}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Inspection Report
                    </a>
                  </p>
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_INCIDENT_REPORT}&projectId=${selectedProject?.ID}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Incident Report
                    </a>
                  </p>
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_CUP_REPORT}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Cup Report
                    </a>
                  </p>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <h6>Dashboards</h6>
                </TableCell>
                <TableCell>
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_DESIGN_DASHBOARD}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Design Dashboard
                    </a>
                  </p>
                </TableCell>
                <TableCell>
                  <p>
                    <a
                      href={`${process.env.REACT_APP_EXP_CONSTRUCTION_DASHBOARD}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      Construction Dashboard
                    </a>
                  </p>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className='border' />

      <div className='main-scope'>
        <div className='high-level' style={{ margin: "1rem 2rem " }}>
          <h6>Scope Changes</h6>
        </div>
        <TableContainer sx={{ padding: "30px" }}>
          <Table>
            <TableHead>
              <TableRow className='scope'>
                {/* <div className='scope'> */}
                <TableCell>
                  <h6>Scope</h6>
                </TableCell>
                <TableCell>
                  <h6>In-Scope</h6>
                </TableCell>
                <TableCell>
                  <h6>Status</h6>
                </TableCell>
                {/* </div> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {projectScope.map((ele) => (
                <TableRow className='high-level'>
                  {/* <div className='high-level'> */}
                  <TableCell style={{ width: "40%" }}>
                    <h6>{ele.PhaseName}</h6>
                  </TableCell>
                  <TableCell style={{ width: "40%" }}>
                    <RadioGroup
                      row
                      value={ele.IsInScope}
                      onChange={(e) =>
                        handleScopeChange(e, ele.PhaseId, "IsInScope")
                      }
                      className='btn'
                    >
                      <FormControlLabel
                        value='Yes'
                        control={<Radio />}
                        label='Yes'
                      />
                      <FormControlLabel
                        value='No'
                        control={<Radio />}
                        label='No'
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className='slider'
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type='range'
                          min='0'
                          max='100'
                          step='1'
                          value={
                            ele.PhasePercentComplete
                              ? ele.PhasePercentComplete
                              : 0
                          }
                          onChange={(e) =>
                            handleScopeChange(
                              e,
                              ele.PhaseId,
                              "PhasePercentComplete"
                            )
                          }
                        ></input>
                        <div style={{ width: "3rem" }}>
                          <b>
                            {ele.PhasePercentComplete
                              ? ele.PhasePercentComplete
                              : 0}
                            %
                          </b>
                        </div>
                      </div>
                      <IconButton
                        color='primary'
                        size='small'
                        onClick={updateScopeStatus}
                        style={{ width: "30px", height: "30px" }}
                      >
                        <CheckIcon fontSize='small' />
                      </IconButton>
                    </div>
                  </TableCell>
                  {/* </div> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className='border' />

      {/* <div className='comments'>
        <h6>Additional Comments</h6>
        <p className='com'>
          Contrary to popular belief, Lorem Ipsum is not simply random text. It
          has roots in a piece of classical Latin literature from 45 BC, making
          it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia
        </p>
      </div>
      <div className='edit'>
        <button>Edit Comments</button>
      </div>
      <div className='border' /> */}

      <div className='scope-changes'>
        <form className='form'>
          <div className='date-scope'>
            <label for='date'>Change in Scope*</label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  format='YYYY-MM-DD'
                  views={["year", "month", "day"]}
                  value={scopeChangeData.date}
                  onChange={(val) =>
                    setScopeChangeData({
                      ...scopeChangeData,
                      date: val,
                    })
                  }
                  shouldDisableYear={(year) =>
                    year.$y < new Date().getFullYear()
                  }
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
          <div className='description-scope'>
            <label for='description'>Description of Scope Changes*</label>
            <textarea
              rows='3'
              placeholder='Enter Description...'
              value={scopeChangeData.description}
              onChange={(e) =>
                setScopeChangeData({
                  ...scopeChangeData,
                  description: e.target.value,
                })
              }
            />
          </div>
        </form>
      </div>
      <div className='submit'>
        <button onClick={handleOnScopeChangeOpen}>View Scope Changes</button>
        <button
          disabled={
            submitScopeDisabled || getUserRoleType() !== "Central GIS Team"
          }
          onClick={handleScopeSubmit}
        >
          Submit
        </button>
      </div>

      <div className='border' />
      <div className='construction_approve_section'>
        <div className='construction_approve_section_container'>
          <div className='construction_approve_section_heading'>
            <h6>Approve For Construction</h6>
            <button
              className='construction_approve_section_heading_btn'
              onClick={() => approveConstruction()}
              disabled={getUserRoleType() !== "Central GIS Team"}
            >
              Approve
            </button>
          </div>
          <div className='construction_approve_section_table'>
            <TableContainer sx={{ padding: "30px" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <h6>
                        <Checkbox
                          color='primary'
                          onClick={(event) => selectAllConstruction(event)}
                          disabled={getUserRoleType() !== "Central GIS Team"}
                        />{" "}
                        Select All
                      </h6>
                    </TableCell>
                    <TableCell>
                      <h6>Service Areas </h6>
                    </TableCell>
                    <TableCell>
                      <h6>Approved For Construction?</h6>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {constructionList.map((ele, i) => (
                    <TableRow key={ele.OBJECTID}>
                      <TableCell>
                        <Checkbox
                          color='primary'
                          checked={ele.isSelected}
                          disabled={
                            ele.isDisabled ||
                            getUserRoleType() !== "Central GIS Team"
                          }
                          onClick={(event) =>
                            selectConstruction(event, ele.OBJECTID)
                          }
                        />
                      </TableCell>
                      <TableCell>{ele.Name}</TableCell>
                      <TableCell>{ele.isDisabled ? "Yes" : "No"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>

      <Dialog
        open={scopeChangeopen}
        onClose={handleOnScopeChangeClose}
        maxWidth='md'
      >
        <div className='view-scope'>
          <div className='scope-header'>
            <h6>View Scope Changes</h6>
            <button onClick={handleOnScopeChangeClose}>
              <X />
            </button>
          </div>
          <div className='border' />
          <div className='changes-container'>
            <ul>
              {projectScopeHistory.map((scopeItem) => (
                <li>
                  <div className='date'>
                    <h6>{formatDate(scopeItem.ScopeChangeDate)}</h6>
                    <p>{scopeItem.ScopeChangeComment}</p>
                  </div>
                  <div className='scope-change'>
                    <div className='scope-level'>
                      <p>
                        <b>Scope: </b>
                      </p>
                      {scopeItem.Changes.map((change) => (
                        <p>{change.PhaseName}</p>
                      ))}
                    </div>
                    <div className='action'>
                      <p>
                        <b>Action: </b>
                      </p>
                      {scopeItem.Changes.map((change) => (
                        <p>{change.Action}</p>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Dialog>
      <div className='border' />

      <div className='month-updates'>
        <div className='tabs'>
          <h6>Monthly Updates</h6>
          <div className={active ? "activetabs" : ""}>
            <button onClick={current}>Current Month</button>
          </div>
          <div className={active ? "" : "activetabs"}>
            <button onClick={previous}>Previous Month</button>
          </div>
        </div>
        {active ? (
          <>
            <div className='bill'>
              <div className='bill-section'>
                <div className='billing-dates'>
                  <h6>Date</h6>
                  <p>{formatDate(currentMonthlyStatus[0]?.StatusDate, true)}</p>
                </div>
                <div className='billing-dates'>
                  <h6>Full Year Billing</h6>
                  <p>{currentMonthlyStatus[0]?.FullYearBillingEst}</p>
                </div>
              </div>
              <div className='qus'>
                <div className='billing-date'>
                  <h6>What are the top risks for your project ?</h6>
                  <p>{currentMonthlyStatus[0]?.RiskName}</p>
                </div>
                <div className='billing-date'>
                  <h6>Do you have enough Resources for this client ?</h6>
                  <p>{currentMonthlyStatus[0]?.HasEnoughResources}</p>
                </div>
                <div className='billing-date'>
                  <h6>Is the work on schedule for this client ?</h6>
                  <p>{currentMonthlyStatus[0]?.IsOnSchedule}</p>
                </div>
              </div>
            </div>
            <div className='insights'>
              <h6>Project Manager Insights</h6>
              <p>{currentMonthlyStatus[0]?.PMInsights}</p>
            </div>
          </>
        ) : (
          <div className='prevoius-month'>
            <TableContainer sx={{ padding: "0 3rem", width: "100%" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Date</b>
                    </TableCell>
                    <TableCell>
                      <b>Full Year Billing</b>
                    </TableCell>
                    <TableCell>
                      <b> What are the top risks for your project ?</b>
                    </TableCell>
                    <TableCell>
                      <b>Do you have enough Resources for this client ?</b>
                    </TableCell>
                    <TableCell>
                      <b>Is the work on schedule for this client ?</b>
                    </TableCell>
                    <TableCell>
                      <b>Project Manager Insights</b>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {monthlyStatus.map((ele) => (
                    <TableRow>
                      <TableCell>{formatDate(ele.StatusDate, true)}</TableCell>
                      <TableCell>{ele.FullYearBillingEst}</TableCell>
                      <TableCell>{ele.RiskName}</TableCell>
                      <TableCell>{ele.HasEnoughResources}</TableCell>
                      <TableCell>{ele.IsOnSchedule}</TableCell>
                      <TableCell>{ele.PMInsights}</TableCell>
                      <TableCell style={{ display: "flex" }}>
                        <IconButton
                          color='primary'
                          onClick={() => handleMonthlyStatusEdit(ele)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color='primary'
                          onClick={() => handleMonthlyStatusDelete(ele)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        <div className='edit'>
          <button onClick={handleOnMonthDetailOpen}>Add Monthly Reports</button>
        </div>
        <Dialog
          open={monthDetailopen}
          onClose={handleOnMonthDetailClose}
          maxWidth='lg'
        >
          <div className='monthupdate-form'>
            <div className='monthupdate-header'>
              <h6>
                {selectedMonthlyStatus.month ? "Edit" : "Add"} Monthly Updates
              </h6>
              <button onClick={handleOnMonthDetailClose}>
                <X />
              </button>
            </div>
            <div className='border' />
            <div className='month-detail'>
              <div className='date-year'>
                <form>
                  <label for='date'>Date</label>
                  <select
                    name='month'
                    value={monthStatusForm.month}
                    onChange={handleStatusChange}
                    disabled={selectedMonthlyStatus.month}
                  >
                    <option selected>{}</option>
                    <option value='01'>Jan</option>
                    <option value='02'>Feb</option>
                    <option value='03'>Mar</option>
                    <option value='04'>Apr</option>
                    <option value='05'>May</option>
                    <option value='06'>Jun</option>
                    <option value='07'>Jul</option>
                    <option value='08'>Aug</option>
                    <option value='09'>Sep</option>
                    <option value='10'>Oct</option>
                    <option value='11'>Nov</option>
                    <option value='12'>Dec</option>
                  </select>
                  <select
                    className='year'
                    name='year'
                    value={monthStatusForm.year}
                    onChange={handleStatusChange}
                    disabled={selectedMonthlyStatus.year}
                  >
                    <option selected>{}</option>
                    {yearOption.map((ele) => (
                      <option value={ele}>{ele}</option>
                    ))}
                  </select>
                </form>

                <form>
                  <label for='risk'>
                    What are the top risks for your project?
                  </label>
                  <select
                    className='risk-option'
                    name='riskStatus'
                    value={monthStatusForm.riskStatus}
                    onChange={handleStatusChange}
                    placeholder='Select risk'
                  >
                    <option selected>{}</option>
                    {riskList.map((ele) => (
                      <option value={ele.RiskId}>{ele.RiskName}</option>
                    ))}
                  </select>
                </form>

                <form>
                  <label for='year billing'>Full Year Billing Est</label>
                  <input
                    type='text'
                    placeholder='Enter full year Billing Est...'
                    name='FullYearBillingEst'
                    value={monthStatusForm.FullYearBillingEst}
                    onChange={handleStatusChange}
                  />
                </form>
              </div>
            </div>
            <div className='main-questions'>
              <div className='questions'>
                <form>
                  <label for='qus'>
                    Do you have enough Resources for this client?
                  </label>
                  <select
                    name='HasEnoughResources'
                    value={monthStatusForm.HasEnoughResources}
                    onChange={handleStatusChange}
                  >
                    <option selected>{}</option>
                    <option>Yes</option>
                    <option>No</option>
                    <option>
                      Yes, but I'll need more resources in the future
                    </option>
                  </select>
                </form>

                <form>
                  <label for='qus'>
                    Is this work on schedule for this client?
                  </label>
                  <select
                    name='IsOnSchedule'
                    value={monthStatusForm.IsOnSchedule}
                    onChange={handleStatusChange}
                  >
                    <option selected>{}</option>
                    <option>Yes</option>
                    <option>No</option>
                    <option>
                      No, but the client is aligned to the current pace
                    </option>
                    <option>
                      Yes, but the client is aware, and the Issues are not
                      within our control
                    </option>
                    <option>
                      No, and we need to align with the client or contractor on
                      the pace
                    </option>
                  </select>
                </form>
              </div>
              <div className='insight'>
                <form>
                  <label for='insight'>Project Manager Insights</label>
                  <textarea
                    rows='3'
                    name='PMInsights'
                    value={monthStatusForm.PMInsights}
                    onChange={handleStatusChange}
                  />
                </form>
              </div>
            </div>
            <div className='reset-submit'>
              <button onClick={() => clearMonthStatusForm()}>Reset</button>
              {selectedMonthlyStatus.month ? (
                <button
                  disabled={disableUpdate}
                  onClick={() => handleMonthlyStatusUpdate()}
                >
                  Submit
                </button>
              ) : (
                <button onClick={() => handleMonthlyStatusSubmit()}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </Dialog>
        <Dialog open={deleteDialog} onClose={closeDelete} maxWidth='md'>
          <div className='delete-dialog'>
            <div className='delete-dialog_header'>
              <h6>Confirmation</h6>
              <button onClick={closeDelete}>
                <X />
              </button>
            </div>
            <div className='border' />
            <div className='delete-dialog_container'>
              <p> Are you sure you want to delete?</p>
              <div className='delete-dialog_actions'>
                <button onClick={closeDelete}>No</button>
                <button
                  variant='contained'
                  onClick={() => deleteMonthlyStatus()}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default NewDetailsPage;
